<template>
<div>
  <div class="ship">
    <div class="ship__short-info">
      <h1 class="ship__title">{{fullName}}</h1>

      <div><router-link :to="all_cruise_link" class="ship-btn-link btn btn--bluefigma">Все круизы теплохода</router-link></div>

<!-- Короткое описание, если его нет, то о теплоходе, первый абзац из полного описания -->
<!-- Длина и ширина, но хз, где он зарыт -->
<!-- capacity -->
    </div>

    <div class="ship__image-block">
        <MySlider
          class="cruise-info__slider"
          :slideRatio="3 / 4"
          :slides="photos"
          srcKey="src_next"
          idKey="id"
          titleKey="title"
        />
    </div>
  </div>

  <div class="ship__full-info">

    <!-- общее описание -->
    <div>
      <a name="about-ship"></a>
      <div class="ship__about">
          <div v-if="has_members()">
            <div class="ship-crew">
                  <h2 class="ship-crew__title">Команда теплохода</h2>
                  <div class="ship-crew__list">
                    <ShipMember :member="captain" title="Капитан" />
                    <ShipMember :member="cruise_director" title="Директор круиза" />
                    <ShipMember :member="restaurant_director" title="Директор ресторана" />
                  </div>
            </div>
          </div>

          <InsertHtml v-bind="descriptionBig" />

      </div>
    </div>

<!-- discounts только в круизках показываем, тут нужно чистить дополнительно ну его -->
    <div v-if="video">
        <iframe width="798" height="449" :src="video" :title="fullName" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
    </div>
<!-- video -->
<!-- photos -->
<!-- scheme -->


<!-- cabins[rand] -->


    <h2 class="ship__section-title">Экскурсии</h2>
    <InsertHtml v-if="excursions.has" v-bind="excursions" />
  </div>

  <h2 class="ship__section-title">Схема теплохода</h2>
  <BigScheme 
      :scheme="props.ship.svgjpg"
      >
  </BigScheme>
  

</div>
</template>

<style lang="scss" src="./Ship.scss"></style>

<script setup>
import useShip from "@/comp/useShip.js"
import { removeHtml } from '@/util.js'
import useCruiseBook from "@/comp/useCruiseBook.js"
import {computed, unref} from 'vue'
import BigScheme from '@/comp/BigScheme/BigScheme.vue'
import MySlider from "@/comp/MySlider/MySlider.vue"
import InsertHtml from '@/comp/IncludedBlock/InsertHtml.vue'
import ShipMember from './ShipMember.vue'


const props = defineProps({
  ship: Object,
  roomDetail: Object, 
})

/*
const { 
    CabinTree
} = useCruiseBook(props)// roomDetail только
*/

const shipOb = useShip(props) // ship только


const { 
    name, fullName, shipId, is_sea,
    photoMain, descriptionBig, 
    photos, video, excursions, 
    captain, cruise_director, restaurant_director,
} = shipOb


const all_cruise_link = { 
    name: 'CruiseList', 
    query: {
        ship: shipId,
        type: is_sea ? 'sea' : 'river',
    }
}

const has_members = () => {
    return captain.is || cruise_director.is || restaurant_director.is
}

</script>
